import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { messages, config } from 'app/constants';
import { DataService, FormatService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

import { find, debounce } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-discount-add',
  templateUrl: './discount-add.component.html',
  styleUrls: ['./discount-add.component.scss'],
})
export class DiscountAddComponent implements OnInit, OnDestroy {
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isQboConnected: boolean = false;
  @Input() defaultTaxable: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() qboItemRefs: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() otherInfo: any = {};
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() discountItemId: string = '';
  @Input() isLocal: boolean = true;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() serviceItem: any = {};
  @Input() openFrom: string = 'catalog';
  @Input() discountOn: string = 'service';
  @Input() orderId: string = '';
  @Input() order: any = {};
  @Input() categories: any[] = [];
  @Input() categoryType: string = '';
  @Input() isFinalizedRo: boolean = false;
  @Input() canEditClassifications: boolean = false;
  @Input('titleForCreate')
  set titleForCreate(title: any) {
    if (title) {
      this.discountItem.title = title;
      this.checkUniqueTitle();
    }
  }
  activityLogs: any[] = [];
  selectedTab: number = 0;
  isSaving: boolean = false;
  isSearching: boolean = false;
  isSearchLoading: boolean = false;
  isOpenFromRO: boolean = false;
  defaultActiveState: boolean = false;
  updateGenericItem: boolean = false;
  isCreateMultiple: boolean = false;
  focus: any = {};
  errors: any = {};
  _qboItemRefs: any[] = [];
  itemResults: any[] = [];
  selectedItems: any[] = [];
  isTitleUnique: boolean = true;
  isCheckingUniqueness: boolean = false;
  qboRefQuery: string = '';
  searchQuery: string = '';
  usd: string = currency.USD;
  isDefault: boolean = false;
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  discountItem: any = {
    title: '',
    titleFR: '',
    type: 'discount',
    qboRef: {},
    locationQboItemRefId: {},
    discountOn: {},
    discountType: 'value',
    discountCap: '',
    discountValue: '',
    status: true,
    isTaxable: true,
    description: '',
    descriptionFR: '',
    internalNotes: '',
    displayHoursOnOrder: true,
    displayDescOnOrder: true,
    category: { name: '' },
  };
  discountOptions: any[] = [
    {
      label: 'RO level discount',
      name: 'RO level discount',
      value: 'order',
      icon: 'far fa-file-alt',
      placeholder: 'RO level discount',
    },
    {
      label: 'Service level discount',
      name: 'Service level discount',
      value: 'service',
      icon: 'far fa-line-columns',
      placeholder: 'Service level discount',
    },
  ];
  localizationSubscription: Subscription;
  isMultiLocationEnabled: boolean = false;
  currentShopId: string = '';
  categoryResults: any[] = [];
  config: any = config;
  isNewCategoriesEnabled: boolean = false;
  customCategory: any = {};
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  companyLocalization: boolean = false;
  currentLang: string = 'en';

  constructor(
    private httpService: HTTPService,
    private formatService: FormatService,
    private dataService: DataService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getLocalizationFlags();
    if (this.dataService.isNewItemCategoriesEnable) this.getAllCategories();

    this.discountItem.discountOn = this.discountOptions[0];
    if (this.order && this.order?.invoiceType === 'refund') {
      this.discountItem.discountType = 'percentage';
    }

    if (this.discountItemId) {
      this.getLogs();
    }
    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
  }



  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.discountItemId) {
          this.discountItem.isTaxable = this.defaultTaxable;
        }
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.currentShopId = localStorage.getItem('currentShop');
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;

        if (this.discountOn) {
          this.discountItem.discountOn = find(this.discountOptions, { value: this.discountOn });
          this.isDefault = this.item && this.item.isDefault;
        }

        this.setItemDetails(this.item);
        this.setCategories(this.categories);
        this.setDiscountData();
        this._qboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        this.isSaving = false;
      }
    }
  }

  getLogs() {
    const query = <any>{};
    query.entityId = this.discountItemId;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  setCategories(categories: any[]) {
    this.categoryResults = [...categories];
  }

  _checkUniqueTitle() {
    this.isCheckingUniqueness = true;
    this.httpService
      .isItemTitleUnique({ title: this.discountItem.title.trim(), type: 'discount' }, this.discountItemId)
      .then(
        (res) => {
          if (!res) {
            this.errors.title = 'Discount name must be unique';
            this.isTitleUnique = false;
            this.helperService.showToaster('error', 'Discount name must be unique');
          } else {
            this.errors.title = '';
            this.isTitleUnique = true;
            this.isCheckingUniqueness = false;
          }
        },
        (err) => {
          console.error(err);
        }
      )
      .finally(() => {
        this.isCheckingUniqueness = false;
      });
  }

  setDiscountData() {
    if (this.serviceItem && this.serviceItem.itemId) {
      this.discountItem = {
        ...this.discountItem,
        cost: this.serviceItem.cost,
        number: this.serviceItem.code ? this.serviceItem.code : this.discountItem.number,
        isTaxable: this.serviceItem.isTaxable,
        status: true,
      };

      if (this.serviceItem.hasOwnProperty('title')) {
        this.discountItem.title = this.serviceItem.title;
      }
      if (this.companyLocalization) {
        if (this.serviceItem.hasOwnProperty('titleFR')) {
          this.discountItem.titleFR = this.serviceItem.titleFR;
        }
      }

      if (this.serviceItem.hasOwnProperty('description')) {
        this.discountItem.description = this.serviceItem.description;
      }

      if (this.serviceItem.hasOwnProperty('descriptionFR')) {
        this.discountItem.descriptionFR = this.serviceItem.descriptionFR;
      }

      if (this.serviceItem.hasOwnProperty('internalNotes')) {
        this.discountItem.internalNotes = this.serviceItem.internalNotes;
      }

      if (this.serviceItem.hasOwnProperty('discountValue')) {
        this.discountItem.discountValue = this.serviceItem.discountValue;
        this.discountItem.prevDiscountValue = this.serviceItem.discountValue;
      }

      if (this.serviceItem.hasOwnProperty('discountType')) {
        this.discountItem.discountType = this.serviceItem.discountType;
      }

      if (this.serviceItem.hasOwnProperty('discountCap')) {
        this.discountItem.discountCap = this.serviceItem.discountCap;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        this.discountItem.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('category') && this.serviceItem.category) {
        this.discountItem.category = {
          ...this.serviceItem.category,
          _id: this.serviceItem.category.categoryId,
        };
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        this.discountItem.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('discountOn')) {
        this.discountItem.discountOn = find(this.discountOptions, { value: this.serviceItem.discountOn });
      }

      if (this.serviceItem.qboId) {
        this.discountItem.itemRef = { qboId: this.serviceItem.qboId };
        this.setItemRef();
      }
    }
  }

  setItemDetails(data: any) {
    if (this.discountItemId && data) {
      this.discountItem = {
        title: data.title,
        titleFR: data.titleFR,
        type: 'discount',
        qboRef: {},
        itemRef: { qboId: data.qboId },
        locationQboItemRefId: data.locationQboItemRefId || {},
        status: data.status,
        isTaxable: data.isTaxable,
        discountType: data.discountType,
        discountValue: data.discountValue,
        description: data.description,
        descriptionFR: data.descriptionFR,
        internalNotes: data.internalNotes,
        discountCap: data.discountCap,
        displayHoursOnOrder: data.displayHoursOnOrder,
        displayDescOnOrder: data.displayDescOnOrder,
        category: data.category || {},
      };

      if (this.isNewCategoriesEnabled) {
        this.discountItem.category = data.category;
      }

      this.defaultActiveState = data.status;

      if (data.discountOn === 'service') {
        this.discountItem.discountOn = this.discountOptions[1];
      } else {
        this.discountItem.discountOn = this.discountOptions[0];
      }
    }

    this.setItemRef();
    this.isSaving = false;
  }

  setItemRef() {
    if (this.discountItem && this.discountItem.itemRef && this.discountItem.itemRef.qboId && this.qboItemRefs.length) {
      this.discountItem.qboRef = find(this.qboItemRefs, {
        qboId: this.discountItem.itemRef.qboId,
      });
    }

    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.discountItem && this.discountItem.locationQboItemRefId && this.discountItem.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.discountItem.locationQboItemRefId[this.currentShopId];
        this.discountItem.itemRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  getQboRefs() {
    this.isSearching = true;
    this.httpService
      .getQBOItemRefs(this.qboRefQuery)
      .then(
        (qboItemRefs: any) => {
          if (qboItemRefs && qboItemRefs.items) {
            this.qboItemRefs = [...qboItemRefs.items];
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  resetData() {
    this.discountItem = {
      title: '',
      type: 'discount',
      qboRef: {},
      discountOn: {},
      discountType: 'percentage',
      discountCap: '',
      discountValue: '',
      status: true,
      isTaxable: true,
      description: '',
      internalNotes: '',
      displayHoursOnOrder: true,
      displayDescOnOrder: true,
      category: { name: '' },
    };
    this.discountItem.discountOn = find(this.discountOptions, { value: 'order' });
    this.focus.name = true;
    this.errors = {};
    this.discountItemId = null;
    this.handleClear();
  }

  handleFocus(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.discountItem.category?.categoryId) this.getSubCategories(this.discountItem.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.discountItem.category?.categoryId && this.discountItem.category?.subCategoryId) this.getSubSubCategories(this.discountItem.category, this.discountItem.category);
    }
  }

  handleBlur(type: string) {
    this.focus[type] = false;

    // if (this.discountItem.title) {
    //   this.checkUniqueTitle();
    // }
  }

  handleClear(type = '') {
    if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.discountItem.qboRef = {};
      this.qboItemRefs = [...this._qboItemRefs];
    }
  }

  handleQboRefSearch(query: string = '') {
    this.qboRefQuery = query;
    this.getQboRefs();
  }

  handleChange(key: string, value: any) {
    this.discountItem[key] = value;

    if (['displayDescOnOrder', 'displayHoursOnOrder', 'status', 'isTaxable'].includes(key)) {
      this.cdr.detectChanges();
    }

    if (this.currentLang === 'en' || this.currentLang === 'EN') {
      if (this.discountItem.title) {
        this.checkUniqueTitle();
      }
    }
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  handleSubmit() {
    if (!this.isValid()) return;

    //added a check while saving if discount type is order then making it false  so customer won't goto service make the discount taxable go back to order save the discount and now they have taxable order discount
    if (this.discountItem && this.discountItem.discountOn && this.discountItem.discountOn.value === 'order') {
      this.discountItem.isTaxable = false;
    }

    this.discountItem.locationQboItemRefId = this.discountItem.locationQboItemRefId || {};
    if (this.discountItem.itemRef && this.discountItem.itemRef.qboId) {
      this.discountItem.qboId = this.discountItem.itemRef.qboId;
      if (this.isMultiLocationEnabled) {
        this.discountItem.locationQboItemRefId[this.currentShopId] = this.discountItem.qboId;
      }
    }

    if (this.discountItemId) {
      this.handleUpdateDiscount();
    } else {
      this.handleCreateDiscount();
    }
  }

  handleCreateDiscount() {
    this.isSaving = true;
    this.httpService
      .createItem(this.formatDiscountData(this.discountItem))
      .then(
        (res) => {
          this.helperService.showToaster('success', messages.discountCreation);
          this.dataService.sendData(this.dataService.typePassData('discount-list', {}));

          // Sending data to RO
          if (this.orderServiceId) {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...res,
                actionType: 'create',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              })
            );
          }

          if (this.openFrom === 'catalog' && this.discountOn === 'service') {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-repairlink-item', {
                ...res,
                actionType: 'create',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              })
            );
          }

          // Cleaning and closing the dialog
          if (!this.isCreateMultiple) {
            this.dynamicDialogRef.close();
          } else {
            this.resetData();
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSaving = false;
      });
  }

  handleUpdateDiscount() {
    if (this.isSaving) return;

    this.isSaving = true;

    if (this.orderServiceId && !this.updateGenericItem) {
      this.isSaving = false;
      this.dynamicDialogRef.close();

      if (this.discountItemId) {
        this.discountItem._id = this.discountItemId;
      }

      if (this.discountItem && this.discountItem.qboRef && this.discountItem.qboRef.qboId) {
        this.discountItem.qboId = this.discountItem.qboRef.qboId;
      }

      this.dataService.sendData(
        this.dataService.typePassData('ro-service-item', {
          ...this.formatDiscountData(this.discountItem),
          actionType: 'update',
          isLocal: true,
          serviceId: this.orderServiceId,
          index: this.orderServiceItemIndex,
        })
      );
    } else if (this.openFrom === 'parts-ordering') {
      this.isSaving = false;
      this.dynamicDialogRef.close();
      this.dataService.sendData(
        this.dataService.typePassData('parts-ordering-item', {
          discount: { ...this.formatDiscountData(this.discountItem) },
          actionType: 'update',
          otherInfo: this.otherInfo,
        })
      );
    } else {
      this.isSaving = true;
      this.httpService
        .updateItem(this.formatDiscountData(this.discountItem))
        .then(
          (discount: any) => {
            this.helperService.showToaster('success', messages.discountUpdate);
            this.dynamicDialogRef.close();
            this.dataService.sendData(this.dataService.typePassData('discount-list', {}));

            if (this.orderServiceId) {
              this.dataService.sendData(
                this.dataService.typePassData('ro-service-item', {
                  ...discount,
                  actionType: 'update',
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                })
              );
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        )
        .finally(() => {
          this.isSaving = false;
        });
    }
  }

  isValid() {
    const { title, titleFR, discountValue, discountCap, discountType, discountOn } = this.discountItem;
    let isValid = true;
    if (this.companyLocalization && this.currentLang.toLowerCase() === 'fr' && !titleFR?.trim()) {
      this.errors.titleFR = 'French Title required*';
      this.helperService.showToaster('error', 'Discount French  title is required');
      isValid = false;
    } else if (this.currentLang.toLowerCase() === 'en') {
      if (!title?.trim()) {
        this.errors.title = 'Title required*';
        this.helperService.showToaster('error', 'Discount title is required');
        isValid = false;
      }
      if (!this.isTitleUnique) {
        this.errors.title = 'Discount name must be unique';
        this.helperService.showToaster('error', 'Discount name must be unique');
        isValid = false;
      }
    }

    if (!discountValue) {
      this.errors.discountValue = 'Discount required*';
      isValid = false;
    }

    if (discountType === 'percentage' && !discountCap) {
      this.errors.discountCap = 'Max discount required*';
      isValid = false;
    }


    return isValid;
  }

  formatDiscountData(data: any) {
    const discountItem: any = {
      title: data.title,
      titleFR: data.titleFR,
      type: 'discount',
      discountCap: data.discountCap,
      isTaxable: data.isTaxable,
      discountType: data.discountType,
      discountValue: data.discountValue,
      displayDescOnOrder: data.displayDescOnOrder,
      displayHoursOnOrder: data.displayHoursOnOrder,
      qboItemRefId: data.itemRef ? data.itemRef.qboId : '',
      locationQboItemRefId: data.locationQboItemRefId || {},
      status: data.status,
      description: data.description,
      descriptionFR: data.descriptionFR,
      internalNotes: data.internalNotes,
      qboId: '',
      count: 1,
      prevDiscountValue: data.prevDiscountValue,
      discountOn: 'percentage',
      category: data.category || {},
    };

    if (data.discountOn && data.discountOn.value) {
      discountItem.discountOn = data.discountOn.value;
    }

    if (data.qboRef && data.qboRef.qboId) {
      discountItem.qboId = data.qboRef.qboId;
    }

    if (this.discountItemId) {
      discountItem._id = this.discountItemId;
    }

    return discountItem;
  }

  onSearchClear() {
    this.itemResults = [];
  }

  onSearchEnter(query: string) { }

  onSearchItem(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  async searchSuggestion(query: string) {
    this.isSearchLoading = true;

    try {
      let data: any;

      if (this.openFrom === 'catalog') {
        data = await this.httpService.getItems({
          limit: 100,
          partAssociationSearch: true,
          search: query.trim(),
        });
      } else {
        data = await this.httpService.searchOrderItems(this.orderId, query.trim());
      }

      this.itemResults = [];

      if (data.records) {
        if (this.selectedItems.length > 0) {
          if (this.openFrom === 'RO') {
            this.itemResults = data.records.filter((el) => !this.selectedItems.find((e) => (e && e.itemInternalReference) === (el && el.itemInternalReference)));
          } else {
            this.itemResults = data.records.filter((el) => !this.selectedItems.find((e) => (e && e._id) === (el && el._id)));
          }
        } else {
          this.itemResults = data.records;
        }
      }
    } catch (err) {
      this.isSearchLoading = false;
      this.helperService.showToaster('error', err);
    } finally {
      this.isSearchLoading = false;
    }
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  saveCategory({ name }) {
    this.createCategory({
      name,
      type: this.categoryType ? this.categoryType : config.tags.discount,
      color: '',
    });
  }

  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category: any) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          this.discountItem.category = category;
          this.categoryResults = [...this.categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onAutoCompleteSelect(event: any, type?: string) {
    if (type === 'tags') {
      this.discountItem.category = event;
    }
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type: this.categoryType ? this.categoryType : type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        if (this.discountItem.category && this.discountItem.category._id === _id) {
          this.discountItem.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  // onCategorySelect(event, isFromCatSearch = true) {
  //   this.discountItem.category.categoryId = '';
  //   this.discountItem.category.name = '';
  //   this.customCategory._id = event.level3 ? event.level3._id : event.level2 ? event.level2._id : event.level1._id;
  //   if (event.level1) {
  //     this.discountItem.category.name = event.level1.categoryName;
  //     this.discountItem.category.categoryId = event.level1.categoryId;
  //     this.customCategory.category = event.level1;
  //     if (isFromCatSearch) {
  //       this.subCategoriesSuggestions = event.level1.subItems;
  //       this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
  //       delete this.customCategory.subCategory;
  //       delete this.customCategory.subSubCategory;
  //     }
  //   }
  //   if (event.level2) {
  //     this.discountItem.category.name += `/${event.level2.subCategoryName}`;
  //     this.discountItem.category.categoryId += `-${event.level2.subCategoryId}`;
  //     this.customCategory.subCategory = event.level2;
  //     if (isFromCatSearch) {
  //       this.subSubCategoriesSuggestions = event.level2.subItems;
  //       this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
  //       delete this.customCategory.subSubCategory;
  //     }
  //   }
  //   if (event.level3) {
  //     this.discountItem.category.name += `/${event.level3.subSubCategoryName}`;
  //     this.discountItem.category.categoryId += `-${event.level3.subSubCategoryId}`;
  //     this.customCategory.subSubCategory = event.level3;
  //   }
  //   this.discountItem.category._id = this.discountItem.category.categoryId;
  //   this.discountItem.category.customCategory = this.customCategory;
  // }

  // categoryDropdownSelect(type, event) {
  //   if (type === 'category' && event.categoryId) {
  //     this.getSubCategories(event);
  //     delete this.customCategory.subCategory;
  //     delete this.customCategory.subSubCategory;
  //     this.onCategorySelect({ level1: event }, false);
  //   }
  //   if (type === 'subCategory' && event.subCategoryId) {
  //     this.getSubSubCategories(this.discountItem.category.customCategory?.category, event);
  //     delete this.customCategory.subSubCategory;
  //     this.onCategorySelect({ level1: this.discountItem.category.customCategory?.category, level2: event }, false);
  //   }
  //   if (type === 'subSubCategory' && event.subSubCategoryId) {
  //     this.onCategorySelect({ level1: this.discountItem.category.customCategory?.category, level2: this.discountItem.category.customCategory?.subCategory, level3: event }, false);
  //   }
  // }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      delete this.discountItem?.category?.subCategoryId;
      delete this.discountItem?.category?.subCategoryName;
      delete this.discountItem?.category?.subSubCategoryId;
      delete this.discountItem?.category?.subSubCategoryName;
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.discountItem?.category?.subSubCategoryId;
      delete this.discountItem?.category?.subSubCategoryName;
      this.getSubSubCategories(this.discountItem.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.discountItem.category.categoryId,
        categoryName: this.discountItem.category.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.discountItem.category.categoryId,
        categoryName: this.discountItem.category.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.discountItem.category.subCategoryId,
        subCategoryName: this.discountItem.category.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload);
  }

  onSelectCategory(event: any) {
    const { category, salesCode } = this.helperService.onCategorySelect(event);

    this.discountItem.category = category;
    this.discountItem.salesCode = salesCode;

    this.subCategoriesSuggestions = [];
    this.subCategoriesSuggestionsResults = [];
    this.subSubCategoriesSuggestions = [];
    this.subSubCategoriesSuggestionsResults = [];
  }

  getAllCategories() {
    const query: any = { itemType: 'discount' };
    this.loader.category = true;
    // if (this.query) query.searchTerm = encodeURI(this.query);
    this.httpService.getPricingCategories(query).then((res: any) => {
      this.categoriesSuggestions = res.categories;
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    }).finally(() => {
      this.loader.category = false;
    });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService.getPricingSubCategories(item.categoryId, 'discount').then((res: any) => {
      if (res && res.subCategories?.length) {
        this.subCategoriesSuggestions = res.subCategories;
        this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
      } else {
        this.subCategoriesSuggestions = [];
        this.subCategoriesSuggestionsResults = [];
      }
    }).finally(() => {
      this.loader.subCategory = false;
    });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService.getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'discount').then((res: any = {}) => {
      if (res && res.subSubCategories?.length) {
        this.subSubCategoriesSuggestions = res.subSubCategories;
        this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
      } else {
        this.subSubCategoriesSuggestions = [];
        this.subSubCategoriesSuggestionsResults = [];
      }
    }).finally(() => {
      this.loader.subSubCategory = false;
    });
  }
}
